import { z } from 'zod';
import { artifactSchema, citationSchema } from './artifacts.js';
import { answerKindSchema, llmUsageSchema, questionOptionSchema, replyLanguageSchema, } from './domain.js';
/**
 * An answer as the core returns it: the text, what it cost, where it came from
 * and the panel beside it. Kept apart from domain.ts because it needs the
 * artifact schemas, which themselves build on domain.ts.
 */
export const answerSchema = z.object({
    kind: answerKindSchema,
    text: z.string(),
    options: z.array(questionOptionSchema),
    language: replyLanguageSchema,
    recordsUsed: z.number().int(),
    usage: llmUsageSchema,
    citations: z.array(citationSchema),
    artifact: artifactSchema.optional(),
});
//# sourceMappingURL=answer.js.map